export default "__VITE_ASSET__D$KG1$1S__"